import { axiosInstance } from "./axiosInstance";

export const getReviewables = async () => {
    const response = await axiosInstance.get("/api/reviews/reviewable");
    return response.data;
};

export const getMyReviews = async () => {
    const response = await axiosInstance.get("/api/reviews/me");
    return response.data;
};

export const addReview = async (data: any) => {
    const response = await axiosInstance.post("/api/reviews", data);
    return response.data;
};

export const getProductReviews = async (productId: number) => {
    const response = await axiosInstance.get(`/api/reviews/product/${productId}`);
    return response.data;
};

// 💡 [관리자] 전체 리뷰 목록 조회
export const getAdminReviews = async () => {
    // 관리자 전용 엔드포인트 호출
    const response = await axiosInstance.get("/api/admin/reviews");
    return response;
};

// 💡 [관리자] 특정 리뷰 삭제
export const deleteAdminReview = async (reviewId: number) => {
    const response = await axiosInstance.delete(`/api/admin/reviews/${reviewId}`);
    return response;
};